import React from 'react'

import Page from '../../../../components/pdf/Page'
import Header from './sections/Header'

import CoverSection from './sections/00.CoverSection'
import RevisionsSection from './sections/00.RevisionsSection'
import IndexSection from './sections/00.IndexSection'
import CompanyInfoSection from './sections/01.CompanyInfoSection'
import IntroSection from './sections/02.IntroSection'
import ObjectiveSection from './sections/03.ObjectiveSection'
import FoundationSection from './sections/04.FoundationSection'
import ResponsabilitiesSection from './sections/05.ResponsabilitiesSection'
import NormsAndReferencesSection from './sections/06.NormsAndReferencesSection'
import MethodologySection from './sections/07.MethodologySection'
import MeasuringEquipmentSection from './sections/08.MeasuringEquipmentSection'
import EnvironmentalConditionSection from './sections/09.EnvironmentalConditionSection'
import TransportInfoSection from './sections/10.TransportInfoSection'
import FurnitureSection from './sections/11.FurnitureSection'
import WorkEnvSection from './sections/12.WorkEnvSection'
import ErgoVerificationSection from './sections/13.ErgoVerificationSection'
import EmployeesAndErgoRisksSection from './sections/14.EmployeesAndErgoRisksSection'
import ConclusiveMappingSection from './sections/15.ConclusiveMappingSection'
import ActionPlanSection from './sections/16.ActionPlanSection'
import ConclusionSection from './sections/17.ConclusionSection'
import SignatureSection from './sections/18.SignatureSection'
import EquipmentCertificateSection from './sections/A.EquipmentCertificateSection'
import StaticTablesSection from './sections/B.StaticTablesSection'

const PdfDocument = ({ serviceOrder, certify }) => {
  return (
    <Page header={<Header />}>
      <CoverSection serviceOrder={serviceOrder} />
      <RevisionsSection serviceOrder={serviceOrder} />
      <IndexSection serviceOrder={serviceOrder} />
      <CompanyInfoSection serviceOrder={serviceOrder} />
      <IntroSection />
      <ObjectiveSection />
      <FoundationSection />
      <ResponsabilitiesSection />
      <NormsAndReferencesSection />
      <MethodologySection />
      <MeasuringEquipmentSection serviceOrder={serviceOrder} certify={certify} />
      <EnvironmentalConditionSection serviceOrder={serviceOrder} />
      <TransportInfoSection serviceOrder={serviceOrder} />
      <FurnitureSection serviceOrder={serviceOrder} />
      <WorkEnvSection serviceOrder={serviceOrder} />
      <ErgoVerificationSection serviceOrder={serviceOrder} />
      <EmployeesAndErgoRisksSection serviceOrder={serviceOrder} certify={certify} />
      <ConclusiveMappingSection serviceOrder={serviceOrder} />
      <ActionPlanSection serviceOrder={serviceOrder} />
      <ConclusionSection serviceOrder={serviceOrder} />
      <SignatureSection serviceOrder={serviceOrder} />
      <EquipmentCertificateSection serviceOrder={serviceOrder} certify={certify} />
      <StaticTablesSection />
    </Page>
  )
}

export default PdfDocument
